<template lang="pug">
    el-dialog(title="成绩管理",width="95%", :visible.sync='visible' :append-to-body="true" :modal-append-to-body='false')
        el-form(:model="ruleForm",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="比赛ID" prop="matchId")
                    div.width_label {{ruleForm.matchId}}
                el-form-item(label="比赛名称" prop="matchName")
                    div.width_label {{ruleForm.matchName}}
                el-form-item(label="比赛类别")
                    div.width_label 俱乐部公开赛
                el-form-item(label="主办单位" prop="orgName")
                    div.width_label {{ruleForm.orgName}}
                el-form-item(label="比赛场地")
                    div.width_label {{ruleForm.placeName}}
                br
                el-form-item(label="赛事类型" prop="ctType")
                    div.width_label(v-if="ruleForm.ctType === 5") 挑战赛
                    div.width_label(v-if="ruleForm.ctType === 6") 群英赛
                    div.width_label(v-if="ruleForm.ctType === 4") 年度总决赛
                el-form-item(label="签位" prop="applySize")
                    div.width_label {{ruleForm.joinCount}}/{{ruleForm.applySize}} 签
                el-form-item(label="比赛时间")
                    div.width_label {{ruleForm.matchStartTime}}
                el-form-item(label="状态")
                    div.width_label(v-if="ruleForm.matchStatus == 2") {{ruleForm.statusName}}
                    div.width_label(v-if="ruleForm.matchStatus == 3") 已取消
                    div.width_label(v-if="ruleForm.matchStatus == 4") 已结束
        el-row(style="padding-top:10px")
            el-col(:span="24")
                el-card(shadow="never")
                    div(slot="header")
                        font.font_label 比赛成绩
                    div
                        //- el-table(:data="gradeData" border)
                        //-     el-table-column(prop="name" label="俱乐部" align="center")
                        //-     el-table-column(prop="chairman" label="会长" align="center")
                        //-     el-table-column(prop="mobile" label="会长账号" align="center")
                        //-     el-table-column(prop="rank" label="排名" align="center")
                        //-         template(slot-scope="scope")
                        //-             el-input-number(v-model="scope.row.rank" :min="0")
                        //-     el-table-column(prop="score" label="积分" align="center" :min="0")
                        //-         template(slot-scope="scope")
                        //-             el-input-number(v-model="scope.row.score")
                        //-     //- 临时加功能
                        //-     el-table-column(prop="score" label="队员积分" align="center" :min="0")
                        //-         template(slot-scope="scope")
                        //-             el-button(type="text" @click="clubMemberInputScore(scope.row)") 编辑
                        //- 二期改造内容,暂时先屏蔽
                        div(class="marginBottom" v-show='primary===1000?false:true')
                            el-button(@click="chooseclublevel(item.key)" v-for='(item,index) in clublevel'  type="text" :class="chooseclublevelNumber===item.key?'choice':'nochoice'") {{item.name}}
                        div(class="marginBottom")
                            div(class="marginBottom")
                            el-button(@click="chooseRound(item)" v-for='(item,index) in roundList' :type="primary===item?'primary':''") {{item}}R
                            el-button(@click="chooseRound(1000)" :type="primary===1000?'primary':''") 排行榜

                        el-table(v-if="!isRoundView" :data="matchTableData" border :span-method="objectSpanMethod" :header-cell-style="headerCellMethod")
                            el-table-column(prop="signNum" label="签位号" align="center")
                            el-table-column(prop="clubName" label="俱乐部" align="center")
                            el-table-column(label="第一双打&得分" align="center")
                              el-table-column(prop="firstPairName" align="center")
                              el-table-column(prop="firstScore" )
                                template(slot-scope="scope")
                                  div(class="scores")
                                    div(class="score") {{scope.row.firstGainScore}}
                                    div(class="sevenScore") {{scope.row.firstRobSevenScore}}
                            el-table-column(label="第二双打&得分" align="center")
                              el-table-column(prop="secondPairName" align="center")
                              el-table-column(prop="secondScore" )
                                template(slot-scope="scope")
                                  div(class="scores")
                                    div(class="score") {{scope.row.secondGainScore}}
                                    div(class="sevenScore") {{scope.row.secondRobSevenScore}}
                            el-table-column(label="第三双打&得分" align="center")
                              el-table-column(prop="thirdPairName" align="center")
                              el-table-column(prop="thirdScore" )
                                template(slot-scope="scope")
                                  div(class="scores")
                                    div(class="score") {{scope.row.thirdGainScore}}
                                    div(class="sevenScore") {{scope.row.thirdRobSevenScore}}
                            //- el-table-column(prop="name" label="操作" align="center" width="320")
                            //-     template(slot-scope="scope")
                            //-         el-button(type="text" @click="changeRoster(scope,1)") 修改一队名单
                            //-         el-button(type="text" @click="changeRoster(scope,2)") 修改二队名单
                            //-         el-button(type="text" @click="updateGrade(scope)") 修改成绩
                            //-         el-button(type="text" @click="viewDispute(scope)") 查看争议
                            //-         el-button(type="text" @click="viewPhotos(scope)") 查看照片打卡
                        el-table(v-if="isRoundView" :data="mockData" border )
                            el-table-column(prop='ranking'  label="名次" align="center" )
                            el-table-column(prop="name" label="姓名" align="center")
                            //- el-table-column(prop="score" label="总得分" align="center")
                            el-table-column(prop="point" label="积分" align="center")
                                template(slot-scope="scope")
                                    font()
                                      span() {{scope.row.point}}
                                      span(style='color:red' v-if='scope.row.pendingUpgrade') 待更新
                            //- el-table-column(prop="upgradePoint" label="升级点数" align="center" )
                            el-table-column(prop="rewardPoint" label="额外积分" align="center" )
                            el-table-column(prop="name" label="操作" align="center" )
                                template(slot-scope="scope")
                                    el-button(type="text" @click="InputPoints(scope)") 录入额外积分
        span.dialog-footer(slot="footer")
            //- el-button(@click="comfirmClick" type="primary") 确 定
            el-button(@click="visible=false") 取 消
        updateGrade(v-if='updateGradeVisible' ref="updageGrade" @refreshList='refreshList')
        viewDispute(v-if='viewDisputeVisible' ref="viewDispute" @refreshList='refreshList')
        InputPoints(v-if='InputPointsVisible' ref="InputPoints" @refreshList='refreshList')
        viewPhotos(v-if='viewPhotosVisible' ref="viewPhotos"  @refreshList='refreshList')
        MemberInput(v-if='clubMemberInputScoreVisible' ref="memberInput")
        //- modifyList(v-if='modifyListVisiable', ref="modifyList" @refreshList='refreshList')
</template>
<script>
import UpdateGrade from './update-grade';
import ViewDispute from './view-dispute';
import ViewPhotos from './view-photos';
import MemberInput from './member-input';
import InputPoints from './InputPoints';
// import modifyList from './modifyList.vue';
import { clubManage } from '@/api/fqSelf/index.js';
export default {
  data () {
    return {
      chooseclublevelNumber: '',
      choseNumber: 1,
      visible: false,
      primary: 1,
      ruleForm: {
        id: null,
        matchType: '1'
      },
      matchTableData: [],
      gradeData: [{ name: '测试' }],
      mockData: [{ name: '测试' }],
      loading: null,
      isRoundView: false,
      updateGradeVisible: false,
      viewDisputeVisible: false,
      viewPhotosVisible: false,
      clubMemberInputScoreVisible: false,
      InputPointsVisible: false,
      clublevel: [],
      roundList: [],
    //   modifyListVisiable: false //修改名单弹出框
    };
  },
  components: {
    UpdateGrade,
    ViewDispute,
    ViewPhotos,
    MemberInput,
    InputPoints,
    // modifyList
  },
  methods: {
    // 排行榜数据获取
    RankingList () {
      this.mockData = [];
      this.$http({
        url: this.$http.adornUrl(
          `/ctCompetition/grade/achievement-manage/team/ranking-list/` +
            this.rowData.id
        ),
        method: 'get'
      }).then(data => {
        if (data.data !== null && data.code === 0) {
          this.mockData = data.data;
          //console.log(this.mockData)
        }
      });
    },
    // 获取伦次
    Round () {
      this.$http({
        url: this.$http.adornUrl(
          `/ctCompetition/operation/player-manage/against-list/rounds/${
            this.rowData.id
          }`
        ),
        method: 'get'
      }).then(data => {
        if (data && data.code === 0) {
          // this.matchTableData = data.data // array
          if (data.data != null) {
            // this.isRoundView = true
            this.roundList = [];
            let round = data.data * 1;
            for (var i = 0; i < round; i++) {
              this.roundList.push(i + 1);
            }
            if (this.primary === -1) {
              //如果等于-1代表第一个进入页面
              this.primary = this.roundList[0];
            }
            this.chooseRound(this.primary);
            // this.choseNumber = 1
            // this.AgainstPlan()
          } else {
            this.chooseRound(1000); //没有轮次跳转到排行榜
            this.matchTableData = [];
            this.roundList = [];
          }
        }
      });
    },
    // 获取级别类型
    Round1 () {
      this.$http({
        url: this.$http.adornUrl(
          `/weChat/referee/getCtRound/${this.rowData.id}`
        ),
        method: 'get'
      }).then(data => {
        if (data && data.code === 0) {
          this.clublevel = data.rounds;
          this.chooseclublevelNumber = data.rounds[0].key;
          this.AgainstPlan();
        }
      });
    },
    AgainstPlan () {
      this.matchTableData = [];
      if (this.primary != '' && this.chooseclublevelNumber != '') {
        let params = {
          ctId: this.rowData.id,
          firstGroup: this.chooseclublevelNumber,
          round: this.primary
        };
        clubManage(params).then(res => {
          if (res.code === 0) {
            let { data } = res;
            let tmpArr = data.map(item => {
              return [
                {
                  ctId: item.ctId,
                  againstId: item.againstId,
                  signNum: item.firstSignNum,
                  clubId: item.clubId1,
                  clubName: item.clubName1,
                  firstPairName: item.firstName1,
                  firstGainScore: item.firstGainScore1,
                  firstRobSevenScore: item.firstRobSevenScore1,
                  secondPairName: item.firstName2,
                  secondGainScore: item.firstGainScore2,
                  secondRobSevenScore: item.firstRobSevenScore2,
                  thirdPairName: item.firstName3,
                  thirdGainScore: item.firstGainScore3,
                  thirdRobSevenScore: item.firstRobSevenScore3
                },
                {
                  ctId: item.ctId,
                  againstId: item.againstId,
                  signNum: item.secondSignNum,
                  clubId: item.clubId2,
                  clubName: item.clubName2,
                  firstPairName: item.secondName1,
                  firstGainScore: item.secondGainScore1,
                  firstRobSevenScore: item.secondRobSevenScore1,
                  secondPairName: item.secondName2,
                  secondGainScore: item.secondGainScore2,
                  secondRobSevenScore: item.secondRobSevenScore2,
                  thirdPairName: item.secondName3,
                  thirdGainScore: item.secondGainScore3,
                  thirdRobSevenScore: item.secondRobSevenScore3
                }
              ];
            });
            let resArr = [];
            tmpArr.forEach(item => {
              resArr.push(item[0]);
              resArr.push(item[1]);
            });
            this.matchTableData = resArr;
          }
        });
      }
    },
    // 队员积分录入
    clubMemberInputScore (row) {
      this.clubMemberInputScoreVisible = true;
      this.$nextTick(() => {
        this.$refs.memberInput.init(row, this.ruleForm.id);
      });
    },
    // 修改成绩操作
    updateGrade (row) {
      this.updateGradeVisible = true;
      this.$nextTick(() => {
        this.$refs.updageGrade.init(
          this.ruleForm.id,
          this.matchTableData[row.$index],
          this.matchTableData[row.$index + 1]
        );
      });
    },
    // 修改录入额外积分
    InputPoints (row) {
      this.InputPointsVisible = true;
      this.$nextTick(() => {
        this.$refs.InputPoints.init(this.rowData.id, row.row.memberId, row);
      });
    },
    // 查看争议
    viewDispute (row) {
      this.viewDisputeVisible = true;
      this.$nextTick(() => {
        this.$refs.viewDispute.init(row, this.choseNumber);
      });
    },
    // 查看照片打卡
    viewPhotos (row) {
      this.viewPhotosVisible = true;
      this.$nextTick(() => {
        // this.$refs.viewPhotos.init(this.rowData.id)
        this.$refs.viewPhotos.init(
          this.rowData.id,
          this.matchTableData[row.$index].againstId,
          this.rowData.id,
          this.choseNumber,
          this.primary,
          this.chooseclublevelNumber
        );
      });
    },
    chooseRound (type) {
      this.primary = type;
      if (type === 1000) {
        this.isRoundView = true;
        this.RankingList();
      } else {
        this.isRoundView = false;
        this.AgainstPlan();
      }
    },
    // 选择第几双打
    choosedoubles (val) {
      this.choseNumber = val;
      this.AgainstPlan();
    },
    chooseclublevel (val) {
      this.chooseclublevelNumber = val;
      this.AgainstPlan();
    },
    init (row, type) {
      // 判断是否需要轮次归位到1
      console.log('团体赛成绩查看')
      if (type) {
        this.primary = type;
      }
      //console.log(row)
      // alert(1)
      this.visible = true;
      this.gradeData = null;
      this.rowData = row;
      //回选
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/getId/` + this.rowData.id),
        method: 'get'
      })
        .then(data => {
          if (data && data.code === 0) {
            this.ruleForm = data.bean;
            let joinCount = this.ruleForm.joinCount; //已报名参赛人员的人数
            let applySize = this.ruleForm.applySize; //赛事签位数
            let date1 = new Date().getTime();
            let date2 = new Date(this.ruleForm.matchStartTime).getTime();
            let date3 = new Date(this.ruleForm.matchSignStartTime).getTime();
            let date4 = new Date(this.ruleForm.matchSignEndTime).getTime();
            if (date1 < date3) {
              this.ruleForm.statusName = '未开始';
            } else if (
              date1 >= date3 &&
              date1 <= date4 &&
              joinCount < applySize
            ) {
              this.ruleForm.statusName = '报名中';
            } else if (
              date1 >= date3 &&
              date1 <= date4 &&
              joinCount >= applySize
            ) {
              this.ruleForm.statusName = '报满可替';
            } else if (date1 > date4 && date1 < date2) {
              this.ruleForm.statusName = '报名结束';
            } else if (date1 >= date2) {
              this.ruleForm.statusName = '已开赛';
            }
            this.ruleForm.orderForm = 1;
          }
          this.RankingList();
        })
        .then(() => {
          // this.getEnrollData(row.id)
        });
      this.RankingList();
      // alert(2)
      this.Round();
      this.Round1();
      this.$nextTick(() => {
        this.AgainstPlan();
      });
    },
    // orderChange () {
    //   this.getEnrollData(this.ruleForm.id)
    // },
    //列表刷新
    // getEnrollData (id) {
    //   let params = { ctId: id }
    //   if (this.ruleForm.projectType == 1) {
    //     //单打默认排序,按照参赛人员年度积分倒序（年度积分为今日之前365天积分和），多的排在前面。
    //     params.orderForm = 0
    //   } else if (this.ruleForm.projectType == 2) {
    //     //双打默认按级别和-积分和排序
    //     params.orderForm = 1
    //   }
    //   this.$http({
    //     url: this.$http.adornUrl(`/elEnroll/getClubScoreList`),
    //     method: 'post',
    //     data: params
    //   }).then((data) => {
    //     if (data && data.code === 0) {
    //       // this.gradeData = [{ 'name': '休斯顿火箭' }] // test
    //       this.gradeData = data.list
    //       for (let i of this.gradeData) {
    //         if (i.score == null) {
    //           i.score = undefined
    //         }
    //         if (i.rank == null) {
    //           i.rank = undefined
    //         }
    //       }
    //     }
    //   })
    // },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 刷新数据
    refreshList () {
      // this.viewPhotosVisible = false
      this.Round();
    },
    // 时间转换
    getMyDate (str) {
      let oDate = new Date(str);
      let oYear = oDate.getFullYear();
      let oMonth = oDate.getMonth() + 1;
      let oDay = oDate.getDate();
      let oHour = oDate.getHours();
      let oMin = oDate.getMinutes();
      let oSen = oDate.getSeconds();
      let oTime =
        oYear +
        '-' +
        this.addZero(oMonth) +
        '-' +
        this.addZero(oDay) +
        ' ' +
        this.addZero(oHour) +
        ':' +
        this.addZero(oMin) +
        ':' +
        this.addZero(oSen);
      return oTime;
    },
    addZero (num) {
      if (parseInt(num) < 10) {
        num = '0' + num;
      }
      return num;
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // if (rowIndex % 2 === 0) {
        //   return {
        //     rowspan: 2,
        //     colspan: 1
        //   }
        // } else {
        //   return {
        //     rowspan: 0,
        //     colspan: 0
        //   }
        // }
      } else if (columnIndex === 8) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    headerCellMethod ({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 1) {
        return { display: 'none' };
      }
    },
    changeRoster (scope, type) {
      this.modifyListVisiable = true;
      if (type === 1) {
        this.$nextTick(() => {
          this.$refs.modifyList.init(
            this.matchTableData[scope.$index],
            this.primary
          );
        });
      } else {
        this.$nextTick(() => {
          this.$refs.modifyList.init(
            this.matchTableData[scope.$index + 1],
            this.primary
          );
        });
      }
    }
    //提交事件
    // comfirmClick () {
    //   let submitData = []
    //   //封装提交数据
    //   let flag = false
    //   for (let i of this.gradeData) {
    //     if (!i.rank) {
    //       this.$message.error('请输入排名!')
    //       flag = true
    //       return
    //     }
    //     if (!i.score && i.score != 0) {
    //       this.$message.error('请输入积分!')
    //       flag = true
    //       return
    //     }
    //     submitData.push({
    //       id: i.scoreId,
    //       matchInfoId: this.ruleForm.id, //赛事id
    //       matchType: 2, //1:分级赛
    //       enrollId: i.id, //报名id
    //       participantInfoId: i.participantInfoId, //报名俱乐部id
    //       participantInfoRealName: i.enrollUserName, //报名人姓名
    //       rank: i.rank,
    //       score: i.score
    //     })
    //   }
    //   if (flag) {
    //     this.$message.error('请输入全部成绩信息!')
    //     return
    //   }
    //   this.openFullScreen()
    //   this.$http({
    //     url: this.$http.adornUrl(`/ctScore/saveOrUpdate`),
    //     method: 'post',
    //     data: submitData
    //   }).then((data) => {
    //     if (data && data.code === 0) {
    //       this.$message({
    //         message: '操作成功',
    //         type: 'success',
    //         duration: 1500,
    //         onClose: () => {
    //           this.visible = false
    //           this.$emit('refreshDataList')
    //         }
    //       })
    //     } else {
    //       this.$message.error('添加失败!')
    //     }
    //     this.loading.close()
    //   })
    // }
  }
};
</script>
<style scoped>
.nochoice {
  color: #606266 !important;
}
.choice {
  color: #02b90d !important;
}
.el-button--text {
  margin-right: 20px;
}
.scores {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.score {
  font-size: 16px;
}
.sevenScore {
  margin-top: -4px;
  font-size: 6px;
}
</style>
